import React from "react";
import {
  Box,
  Typography,
  TextField,
} from "@mui/material";
import { StepProps } from "../types";

const ProjectDetailsStep: React.FC<StepProps> = ({
  data,
  onUpdateData,
}) => {
  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onUpdateData({ name: e.target.value });
  };

  const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onUpdateData({ description: e.target.value });
  };


  return (
    <Box sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center", bgcolor: "#f5f5f5", p: 3 }}>
      {/* Centered Form Container */}
      <Box sx={{ maxWidth: 600, width: "100%" }}>
        <Typography
          variant="h5"
          sx={{
            mb: 1,
            fontWeight: 600,
            color: "#1a1a1a",
            textAlign: "center",
          }}
        >
          Project Details
        </Typography>
        <Typography
          variant="body2"
          sx={{
            mb: 4,
            color: "#666",
            textAlign: "center",
          }}
        >
          Basic information about your project
        </Typography>

        <Box sx={{ mb: 3 }}>
          <Typography
            variant="subtitle1"
            sx={{
              mb: 1,
              fontWeight: 500,
              color: "#1a1a1a",
            }}
          >
            Project Name
          </Typography>
          <TextField
            fullWidth
            placeholder="Enter your project name"
            value={data.name}
            onChange={handleNameChange}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: "white",
              },
            }}
          />
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography
            variant="subtitle1"
            sx={{
              mb: 1,
              fontWeight: 500,
              color: "#1a1a1a",
            }}
          >
            Project Description
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            placeholder="Describe your project goals and objectives..."
            value={data.description}
            onChange={handleDescriptionChange}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: "white",
              },
            }}
          />
        </Box>

        {/* Global navigation bar handles Next/Previous */}
      </Box>
    </Box>
  );
};

export default ProjectDetailsStep;
